import * as React from 'react'
import { ReactElement, useContext, useEffect } from 'react'
import FileMessage from '../../components/FileMessage/FileMessage'
import MessageContext from '../../context/MessageContext'
import GlobalEmailFilingOverview from './GlobalEmailFilingOverview'
import { MenuItemKey } from '../../components/MainMenu'
import { AppAction } from '../../config/appConfig'
import { useDispatch } from 'react-redux'
import { FileAction } from '../../config/fileConfig'

export default function GlobalEmailOverview(): ReactElement {
    const dispatch = useDispatch()
    const { outlookMessage } = useContext(MessageContext)

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Emails] })
        dispatch({ type: FileAction.ResetCurrent })
    }, [])

    if (outlookMessage) {
        return <FileMessage />
    }

    return <GlobalEmailFilingOverview />
}
